import _ from 'lodash';

export class EnrolUtil {

  public formatEntList(entIdList:string[]):Array<{entId: string, displayName:string}> {

    return entIdList
      .map(item => ({entId: item, displayName: item.replace(/\./g, ' > ')}));
  }

}

